import React, {useState} from 'react';
import '../YogaAanHuisPage/Styles.css';
import useTitle from '../../useTitle';
import { Link } from 'react-router-dom';  // Import Link from react-router-dom
import ContactSection from '../ContactSection/Index';

const YogaAanHuis = () => {
  useTitle("Privélessen");
   // eslint-disable-next-line no-unused-vars
      const [isOpen, setIsOpen] = useState(false);
      // Close the navbar when a link is clicked
      const handleLinkClick = (url) => {
          setIsOpen(false); // Close the navbar
          window.location.href = url; // Force navigation to the specific URL
      };
  return (
    <>
      <div className='yogaAanHuisContainer'>
          <div className='yogaAanHuisAllContainer'>
            <div className='yogaAanHuisImageHeaderContainer'>
              <img src='/images/Agija-41-800.jpg' alt='yoga aan huis header' className='yogaAanHuisHeader'  srcSet="
                  /images/Agija-41-800.jpg 800w,
                  /images/Agija-41-1200.jpg 1200w,
                  /images/Agija-41-1600.jpg 1600w
                "
                sizes="(max-width: 768px) 100vw, 742px" />
            </div>
            <div className='yogaAanHuisTextAll'>
              <div className='yogaAanHuisTitleContainer'>
                <h1 className='yogaAanHuisTitle'>Privélessen</h1>
              </div>

              <div className='yogaAanHuisDescriptionContainer'>
                <p>Wil je starten met yoga, maar liever niet in een groep? of heb je nood aan persoonlijke begeleiding die volledig afgestemd is op jouw lichaam en levensstijl?</p>
                <br />
                <p>Met privé yoga aan huis kom ik naar jou in regio Antwerpen, zodat jij in alle rust en zonder verplaatsing kan werken aan meer ontspanning, flexibiliteit en energie. Woon je buiten deze regio? Dan bekijken we samen wat mogelijk is.</p>
                <br />
                <p>De sessies worden volledig op maat opgebouwd en duren 60 minuten of langer, afhankelijk van jouw noden. Of je nu:</p>
                <ul className='priveYogaList'>
                  <li>Last hebt van stress of spanning</li>
                  <li>Fysieke klachten ervaart (zoals rug- of nekpijn)</li>
                  <li>Of gewoon een moment voor jezelf wil creëren</li>
                </ul>
              </div>

              <div className='waaromYogaAanHuisDescriptionContainer'>
                <p>We werken samen op jouw tempo en met oefeningen die echt bij jou passen.</p>
                <br />
                <p>Geen standaard les, maar persoonlijke aandacht en begeleiding die je helpt om je beter in je lichaam te voelen zowel fysiek als mentaal.</p>
              </div>

              <div className='ontdekYogaAanHuisTitleContainer'>
                <h2 className='ontdekYogaAanHuisTitle'>Wil je ontdekken wat yoga voor jou kan doen? Neem gerust contact op voor een eerste sessie.</h2>
              </div>

              <div className='ontdekYogaAanHuisButtonContainer'>
                <Link onClick={() => handleLinkClick('/contact')}  className='ontdekYogaAanHuis'>Ja, graag!</Link>
              </div>

            </div>
          </div>

      </div>

      {/* Contact/Menu Section */}
      <ContactSection />
    </>
  )
}

export default YogaAanHuis;